/**
 * @class
 * @classdesc Model for Campaign on DB
 * * */
export default class Campaign {
  /**
   *Constructor - sets a model for campaign Data according to DB
   * @param {String} id
   * @param {String} name
   * @param {String} description
   * @param {String} validInType
   * @param {Array.<Place>} places
   * @param {String} region
   * @param {Array} zones
   * @param {Number} maxNumberOfRegistrants
   * @param {Number} discountPercent
   * @param {String} validFrom
   * @param {String} validTo
   * @param {String} campaignCode
   * @param {String} notificationEmails
   * @param {Boolean} autoApprove
   * @param {String} approvalMessage
   * @param {Array.<DiscountCampaignRegistrant>} registrants
   * @param {String} publicRegistrationLinkUuid
   * @param {Boolean} isPublicRegistrationLinkEnabled
   * @param {String} appInfoText
   * @param {String} type
   * @param {Boolean} paymentMethodRequired
   * @param {Boolean} oneTimeDiscount
   * @param {Boolean} forNewClientsOnly
   * @param {Number} discountCreditInCents
   * @param {String} discountCreditCurrency
   * @param {Boolean} startSessionsWithLPR
   * @param {String} registrationOpenUntil
   * @param {Boolean} isTemplate
   * @param {<Icon>} appIcon
   * @param {Number} appIconId
   * @param {String} appId
   * @param {Array<PromoCodes>} promoCodes
   * @param {String} registrationRequestReceivedMessage
   */

  #FleetObject = {}

  constructor(
    id,
    name,
    description,
    validInType,
    places,
    region,
    zones,
    maxNumberOfRegistrants,
    discountPercent,
    validFrom,
    validTo,
    campaignCode,
    notificationEmails,
    autoApprove,
    approvalMessage,
    registrants,
    publicRegistrationLinkUuid,
    isPublicRegistrationLinkEnabled,
    appInfoText,
    type,
    paymentMethodRequired,
    oneTimeDiscount,
    forNewClientsOnly,
    discountCreditInCents,
    discountCreditCurrency,
    startSessionsWithLPR,
    registrationOpenUntil,
    isTemplate,
    appIcon,
    appIconId,
    appId,
    promoCodes,
    registrationRequestReceivedMessage
  ) {
    this.#FleetObject.ID = id || 0
    this.#FleetObject.Name = name || ''
    this.#FleetObject.Description = description || ''
    this.#FleetObject.ValidInType = validInType || 'PLACES'
    this.#FleetObject.Places = places || []
    this.#FleetObject.Region = region || ''
    this.#FleetObject.Zones = zones || []
    this.#FleetObject.MaxNumberOfRegistrants = maxNumberOfRegistrants || null
    this.#FleetObject.DiscountPercent = discountPercent || null
    this.#FleetObject.ValidFrom = validFrom || this.getValidFrom()
    this.#FleetObject.ValidTo = validTo || this.getValidTo()
    this.#FleetObject.CampaignCode = campaignCode || ''
    this.#FleetObject.NotificationEmails = notificationEmails || ''
    this.#FleetObject.AutoApprove = autoApprove || false
    this.#FleetObject.ApprovalMessage = approvalMessage || ''
    this.#FleetObject.Registrants = registrants || []
    this.#FleetObject.PublicRegistrationLinkUuid =
      publicRegistrationLinkUuid || ''
    this.#FleetObject.IsPublicRegistrationLinkEnabled =
      isPublicRegistrationLinkEnabled || false
    this.#FleetObject.AppInfoText = appInfoText || ''
    this.#FleetObject.Type = type || 'DISCOUNT_PERCENT'
    this.#FleetObject.PaymentMethodRequired = paymentMethodRequired || false
    this.#FleetObject.OneTimeDiscount = oneTimeDiscount || false
    this.#FleetObject.ForNewClientsOnly = forNewClientsOnly || false
    this.#FleetObject.DiscountCreditInCents = discountCreditInCents || 0
    this.#FleetObject.DiscountCreditCurrency = discountCreditCurrency || 'EUR'
    this.#FleetObject.StartSessionsWithLPR = startSessionsWithLPR || false
    this.#FleetObject.RegistrationOpenUntil = this.getRegistrationOpenUntil()
    this.#FleetObject.IsTemplate = isTemplate || false
    this.#FleetObject.AppIcon = appIcon || {}
    this.#FleetObject.AppIconId = appIconId || 0
    this.#FleetObject.AppId = appId || 1
    this.#FleetObject.PromoCodes = promoCodes || []
    this.#FleetObject.RegistrationRequestReceivedMessage =
      registrationRequestReceivedMessage ||
      'Your registration request has been received. You will receive a confirmation email when your registration is confirmed.'
  }

  getValidFrom() {
    if (!this.validFrom) {
      return null
    }
    return this.validFrom
  }

  getValidTo() {
    if (!this.validTo) {
      return null
    }
    return this.validTo
  }

  getRegistrationOpenUntil() {
    if (!this.registrationOpenUntil) {
      return null
    }
    return this.registrationOpenUntil
  }

  /**
   * Get Fleet Object
   * @return {Object} Fleet Javascript object
   */
  getObject() {
    return this.#FleetObject
  }
}
